import PlayerStats from './components/PlayerStats';

export default function SummaryStats({ data }) {
  const {
    AnalysisData: { PlayerAStats, PlayerBStats },
    AIData: {
      AIResponse: { RecieveAnalysis },
    },
  } = data;

  return (
    <>
      <div className="grid grid-cols-2 gap-4 mb-4 border-b-1">
        <PlayerStats data={RecieveAnalysis.PlayerA} label="Summary Stats" />
        <PlayerStats data={RecieveAnalysis.PlayerB} label="Summary Stats" />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <PlayerSummaryStats stats={PlayerAStats} />
        <PlayerSummaryStats stats={PlayerBStats} />
      </div>
    </>
  );
}

const PlayerSummaryStats = ({ stats }) => {
  return (
    <div className="grid gap-4">
      <div className="d-flex flex-column align-items-center">
        <div className="text-tertiary-100 text-xs mb-2">Serve Point</div>
        <div className="text-success">{stats?.ServePoint || '-'}</div>
      </div>
      <div className="d-flex flex-column align-items-center">
        <div className="text-tertiary-100 text-xs mb-2">Total Serve Errors</div>
        <div className="text-destruction">{stats?.ServerError || '-'}</div>
      </div>
      <div className="d-flex flex-column align-items-center">
        <div className="text-tertiary-100 text-xs mb-2">Service Returns Wins</div>
        <div className="text-success">{stats?.ServeReturnWin || '-'}</div>
      </div>
      <div className="d-flex flex-column align-items-center">
        <div className="text-tertiary-100 text-xs mb-2">Service Returns Errors</div>
        <div className="text-destruction">{stats?.ServeReturnError || '-'}</div>
      </div>
      <div className="d-flex flex-column align-items-center">
        <div className="text-tertiary-100 text-xs mb-2">Win on 3rd ball</div>
        <div className="text-success">{stats?.PointsOn3rdBall || '-'}</div>
      </div>
      <div className="d-flex flex-column align-items-center">
        <div className="text-tertiary-100 text-xs mb-2">Errors on 3rd ball</div>
        <div className="text-destruction">{stats?.ErrorsOn3rdBall || '-'}</div>
      </div>
    </div>
  );
};
